import React from "react";
import classnames from "classnames";
import {
    DownloadIcon,
    DuplicateIcon,
    PencilIcon,
    TrashIcon,
} from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

import {
    store as generalSettingStore,
    setIsActionsClicked,
    setIsEdited,
    setActions,
} from "./store";

import { copyUrl, downloadQRCode } from "./helpers";

type CustomIconsType = {
    e: any;
    qrCodeRefs: any;
    setRowData: Function;
    setIsAddLocationClicked: Function;
    setLocalFilterActive: Function;
    setIsValidateDeleteOpened: Function;
};

export function CustomIcons({
    e,
    qrCodeRefs,
    setRowData,
    setIsAddLocationClicked,
    setLocalFilterActive,
    setIsValidateDeleteOpened,
}: CustomIconsType) {
    const { t } = useTranslation();
    const { isActionsClicked, isEdited } = useSnapshot(generalSettingStore);

    return (
        <React.Fragment>
            {e.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    <Tooltip title={t("To copy")}>
                        <span
                            style={{
                                cursor: "pointer",
                            }}
                            onClick={() => copyUrl(e.selectedRow.qrData, t)}
                        >
                            <DuplicateIcon height={20} width={20} />
                        </span>
                    </Tooltip>
                    <Tooltip title={t("Download")}>
                        <label
                            className={`${classnames("pointer__clz ", "ml-3")}`}
                            onClick={() =>
                                downloadQRCode(e.selectedRow.Id, qrCodeRefs, t)
                            }
                        >
                            <DownloadIcon height={20} width={20} />
                        </label>
                    </Tooltip>
                    <Tooltip title={t("To modify")}>
                        <div>
                            <PencilIcon
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(() => {
                                            setIsEdited(false);
                                            setRowData(e.selectedRow);
                                            setIsAddLocationClicked(true);
                                            setLocalFilterActive(false);
                                        });
                                    } else {
                                        setRowData(e.selectedRow);
                                        setIsAddLocationClicked(true);
                                        setLocalFilterActive(false);
                                    }
                                }}
                                height={25}
                                width={25}
                                style={{ cursor: "pointer" }}
                                className={`${classnames(
                                    "pointer__clz cmn_icn_FRedit",
                                    "ml-3"
                                )}`}
                            />
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Delete")}>
                        <div>
                            <TrashIcon
                                onClick={async () => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(async () => {
                                            setIsAddLocationClicked(false);
                                            setIsEdited(false);
                                            setRowData(e.selectedRow);
                                            setIsValidateDeleteOpened(true);
                                        });
                                    } else {
                                        setIsAddLocationClicked(false);
                                        setRowData(e.selectedRow);
                                        setIsValidateDeleteOpened(true);
                                    }
                                }}
                                height={25}
                                width={25}
                                fill="red"
                                style={{
                                    cursor: "pointer",
                                }}
                                className="pointer__clz ml-3"
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
